/**
 * Convenção visual da Dash Gerencial: placeholder vs dado real.
 *
 * Os títulos dos containers usam vermelho vivo enquanto aquele bloco ainda é
 * placeholder (valores fictícios, sem API). A cor não é decoração: ela marca
 * para o dono da plataforma e para IAs o que ainda não é produção.
 *
 * - Título em vermelho vivo: o card ainda é placeholder. Não tratar os
 *   números daquele bloco como verdadeiros.
 * - Título na cor normal (cinza/preto): o bloco já consome valores reais.
 *
 * Números, legendas, tabelas e filtros ficam nas cores atuais (cinza/preto
 * e paleta dos gráficos). Só o título do container muda.
 *
 * Quando um bloco passar a usar dados reais, remover `placeholderTitleClass`
 * daquele título para ele voltar à cor normal.
 */
import styles from './placeholder-ui.module.css'

export const placeholderTitleClass = styles.placeholderTitle

export function withPlaceholderTitle(className: string): string {
  return `${className} ${placeholderTitleClass}`
}
